import type {ReactElement} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {Text, TextSize} from '@Components/text';
import styles from './contextual-menu-heading-option.module.scss';
import type { PillContent} from '@Components/pill';
import {Pill, PILL_BACKGROUND_COLOR, PILL_SIZE} from '@Components/pill';

interface ContextualMenuHeadingOptionProps {
  id: string;
  className?: string;
  text: string;
  textClasses?: string;
  pillContent?: PillContent;
}

export function ContextualMenuHeadingOption({className = '', textClasses = '', ...props}: ContextualMenuHeadingOptionProps): ReactElement<any> | null {
  const getHeadingContent = (): ReactElement<any> => {
    return (
      <div className={`${styles.headingContainer} ${textClasses} `}>
        <div className={'flexbox '}>
          <Text val={props.text} size={TextSize.XSMALL} className={'spacing-m-r-1'} bold />
          {props.pillContent !== undefined ? (
            <Pill
              content={props.pillContent}
              background={PILL_BACKGROUND_COLOR.SECONDARY_100}
              className={`spacing-p-t-1 spacing-p-b-1 spacing-p-l-4 spacing-p-r-4 ${styles.pill}`}
              size={PILL_SIZE.XSMALL}
            />
          ) : null}
        </div>
        <div className={`${styles.line} spacing-m-t-1`} />
      </div>
    );
  };
  return <Option className={className} key={props.id} optionControl={getHeadingContent()} />;
}
